import React from 'react';

export const BriefcaseIcon = ({ className }) => {
	return (
		<svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M1 6.80114V4.6159C1 2.61285 2.63364 1 4.64922 1H19.3627C21.3783 1 23 2.61285 23 4.6159V6.80114M1 6.80114C3.2821 8.29693 6.01633 9.34457 9.01709 9.75961C9.37642 8.45774 10.5579 7.50351 11.9941 7.50351C13.4076 7.50351 14.6129 8.45774 14.9484 9.77143C17.9611 9.35639 20.706 8.30875 23 6.80114M1 6.80114V13C1 15.2091 2.79086 17 5 17H19C21.2091 17 23 15.2091 23 13V6.80114" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
};
